import React from "react";
import { StarIcon } from "lucide-react";
import { Reveal } from "./ui";
const stats = [{
  value: "6",
  label: "Tomos"
}, {
  value: "3",
  label: "Bonos"
}, {
  value: "+500",
  label: "Páginas"
}, {
  value: "∞",
  label: "Acceso de por vida"
}];
export function SocialStrip() {
  return <section className="w-full border-y border-[#eef2f6] bg-[var(--calm-blue)]/50 px-4 py-9 sm:px-8 sm:py-14" data-id="element-233" data-mp="3on112l7zdx48">
      <div className="mx-auto max-w-4xl text-center" data-id="element-234" data-mp="g7hdo2tzr8x3">
        <Reveal data-id="element-235" data-mp="g5wiqc3rlnyp">
          <div className="mb-3 flex items-center justify-center gap-2" data-id="element-236" data-mp="l6k7er4itspr">
            <div className="flex text-[#f0b429]" data-id="element-237" data-mp="l4pv217bf8xa">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden data-id="element-238" data-mp="79domwjsru0j" data-mpi={i} />)}
            </div>
            <span className="text-sm font-bold text-[var(--ink)]" data-id="element-239" data-mp="2rxjn7iyuh4rg">4.9/5</span>
          </div>
          <p className="mx-auto max-w-md font-serif-display text-xl leading-snug text-[var(--ink)] sm:max-w-2xl sm:text-3xl" data-id="element-240" data-mp="2wwd3tk9fhbvu">
            Más de 500 familias ya comenzaron a acompañar a sus hijos con mayor
            tranquilidad.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-241" data-mp="92bi2nwuu90x">
          <div className="mt-6 grid grid-cols-4 gap-2 sm:mt-10 sm:gap-4" data-id="element-242" data-mp="ny14uo9v6q6p">
            {stats.map(s => <div key={s.label} className="rounded-xl border border-[#e6eef5] bg-white px-1.5 py-3 shadow-[0_10px_30px_-18px_rgba(31,51,69,0.35)] sm:rounded-2xl sm:px-4 sm:py-6" data-id="element-243" data-mp="iz7psrexir4f">
                <div className="font-serif-display text-xl font-semibold text-[var(--accent)] sm:text-3xl" data-id="element-244" data-mp="s0e6b0hkw1xo">
                  {s.value}
                </div>
                <div className="mt-1 text-[9px] font-semibold leading-tight text-[var(--muted)] sm:text-xs" data-id="element-245" data-mp="16qd7zd8cdvhw">
                  {s.label}
                </div>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}